export const addManufacturer = ({ form }) => {
    form.setConfig({
        "title": "Add Manufacturer",
        "type": "push",
        "location": "Database/Manufacturers",
        "fields": [{
            "label": "Name",
            "name": "Name",
            "type": "text"
        }]
    });
    form.toggle();
}

export const editManufacturer = ({ form, rowItem }) => {
    form.setValues({
        "Name": rowItem.Name
    });
    form.setConfig({
        "title": "Edit Manufacturer",
        "type": "update",
        "location": `Database/Manufacturers/${rowItem.ID}`,
        "fields": [{
            "label": "Name",
            "name": "Name",
            "type": "text"
        }]
    });
    form.toggle();
}
